import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LucideAngularModule, LucideIconData } from 'lucide-angular';
import { ButtonModule } from 'primeng/button';

export interface InformationScreenProperties {
  error?: {
    code: string;
    summary: string;
  };
  details?: {
    icon: LucideIconData;
    summary: string;
  };
  message?: string;
  action?: {
    label: string;
    route?: string;
    callback?: () => void;
  };
}

@Component({
  selector: 'app-information-screen',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonModule, LucideAngularModule, RouterModule],
  templateUrl: './information-screen.html',
  styleUrl: './information-screen.css',
})
export class InformationScreenComponent {
  information = input.required<InformationScreenProperties>();
}
